<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import PageLayout from 'dashboard/components-next/captain/PageLayout.vue';
import SettingsHeader from 'dashboard/components-next/captain/pageComponents/settings/SettingsHeader.vue';
import ToolSelectionPanel from 'dashboard/components-next/captain/pageComponents/assistant/tabs/ToolSelectionPanel.vue';

// A tela de ferramentas virou a aba "O que pode fazer" (02/09/2026). Esta rota
// fica como destino dos links antigos e reaproveita o mesmo painel.
const route = useRoute();
const assistantId = computed(() => Number(route.params.assistantId));
const backUrl = computed(() => ({
  name: 'captain_assistants_settings_index',
  params: { accountId: route.params.accountId, assistantId: assistantId.value },
  query: { aba: 'o-que-pode-fazer' },
}));
</script>

<!-- eslint-disable vue/no-bare-strings-in-template -->
<template>
  <PageLayout
    header-title="Ferramentas"
    :back-url="backUrl"
    :show-know-more="false"
    :show-pagination-footer="false"
    :show-assistant-switcher="false"
  >
    <template #body>
      <SettingsHeader
        heading="Ferramentas"
        description="Escolha quais ações o agente pode executar. FAQ e Transferir para humano são essenciais e ficam sempre ativas."
      />
      <div class="mt-7">
        <ToolSelectionPanel :assistant-id="assistantId" />
      </div>
    </template>
  </PageLayout>
</template>
